/* eslint-disable import/no-anonymous-default-export */
import Routes from "./Routes";
import Theme from "./Theme";
import NavBoxItems from "./NavBoxItems";
import NavigationItems from "./NavigationItems";
import HeaderNavItems from "./HeaderNavItems";

export default {
  ENV: process.env,

  GoogleIndex: false,

  // Panel Core Config
  Panel: "Passenger",
  PanelName: "به‌همراه",
  PanelTitle: "سفرهای همزمان گروهی",
  PanelLogo:
    require("@package/behamrah-core/dist/assets/images/logo/logotype.svg")
      .default,
  PanelLogoWhite:
    require("@package/behamrah-core/dist/assets/images/logo/logotype-white.svg")
      .default,
  PanelLogoMark:
    require("@package/behamrah-core/dist/assets/images/logo/logomark.png")
      .default,

  // Routing Config
  Routes,
  HomePageRoute: "/app",

  // UI Config
  Theme,
  NavBoxItems,
  NavigationItems,
  HeaderNavItems,

  // Auth Page UI Config
  AuthPage: {
    title: "سفرهای همزمان گروهی",
    image:
      require("@package/behamrah-core/dist/assets/images/auth/passenger.png")
        .default,
    imageStyle: { width: "95%", maxWidth: "350px" },
    text: "سفرهای کاری، تحصیلی و تفریحی خود را با برنامه انجام دهید؛ از قبل رزرو کنید و هزینه‌های خود را مدیریت کنید.",
  },
};
